"use strict";
class bb_omekaAPI {
  constructor() {}
  getTotalItems(request) {
    return fetch(request)
      .then(
        function (response) {
          return response.json();
        }.bind(this)
      )
      .then(
        function (data) {
          return data.items.total;
        }.bind(this)
      )
      .catch(function (error) {
        console.log("getTotalItems FETCH ERROR:", error);
      });
  }
  getItemOnly(request) {
    return fetch(request)
      .then(
        function (response) {
          return response.json();
        }.bind(this)
      )
      .then(
        function (data) {
          return data;
        }.bind(this)
      )
      .catch(function (error) {
        console.log("getItemOnly FETCH ERROR:", error);
      });
  }
  getItemWithAllMedia(request) {
    return fetch(request)
      .then(
        function (response) {
          return response.json();
        }.bind(this)
      )
      .then(
        function (data) {
          this.itemData = data[0];
          return data;
        }.bind(this)
      )
      .then(
        function (result) {
          let media_links = Array.from(this.itemData["o:media"], (x) => x["@id"]);
          return media_links;
        }.bind(this)
      )
      .then(
        function (media_links) {
          return Promise.all(media_links.map((url) => fetch(url).then((response) => response.json())));
        }.bind(this)
      )
      .then(
        function (media_response) {
          let medias = [];
          media_response.forEach((element, index) => {
            medias.push(element);
          });
          this.itemData["o:media"] = medias;
          return;
        }.bind(this)
      )
      .then(
        function () {
          if (this.itemData["o-module-mapping:marker"]) {
            return fetch(this.itemData["o-module-mapping:marker"][0]["@id"]).then((response) => response.json());
          } else {
            return false;
          }
        }.bind(this)
      )
      .then(
        function (marker) {
          if (marker) {
            this.itemData["o-module-mapping:marker"][0] = "";
            this.itemData["o-module-mapping:marker"][0] = marker;
          }
          return this.itemData;
        }.bind(this)
      )
      .catch((error) => {
        console.log("getItemWithAllMedia FETCH ERROR:", error);
      });
  }
}

const omekaAPI = new bb_omekaAPI();
